<li class="{{type}}">
  <p>
    <span class="title" (click)="onSelect($event)">{{title}}</span>
    <span class ="subtitle" [hidden]="subtitle==''">{{subtitle}}</span>
  </p>
  <span class="action" [hidden]="actionText==''" (click)="onAction($event)">{{actionText}}</span>
</li>
